import React, { useRef, useEffect } from "react";

interface OTPInputProps {
  length?: number;
  value: string[];
  onChange: (otp: string[]) => void;
  onComplete?: (otp: string) => void;
  error?: string;
  touched?: boolean;
}

const OTPInput: React.FC<OTPInputProps> = ({
  length = 5,
  value,
  onChange,
  onComplete,
  error,
  touched,
}) => {
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  useEffect(() => {
    inputRefs.current[0]?.focus();
  }, []);

  const handleChange = (index: number, inputValue: string) => {
    if (inputValue.length > 1) {
      inputValue = inputValue.slice(-1);
    }

    if (!/^\d*$/.test(inputValue)) {
      return;
    }

    const newOtp = [...value];
    newOtp[index] = inputValue;
    onChange(newOtp);

    if (inputValue && index < length - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    const otpString = newOtp.join('');
    if (otpString.length === length && onComplete) {
      onComplete(otpString);
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && !value[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, length).replace(/\D/g, '');
    if (pastedData.length === length) {
      const newOtp = pastedData.split('').slice(0, length);
      onChange(newOtp);
      inputRefs.current[length - 1]?.focus();
    }
  };

  return (
    <div className="otp-input-container">
      <div className="otp-inputs">
        {Array.from({ length }).map((_, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={value[index] || ''}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={index === 0 ? handlePaste : undefined}
            className={touched && error ? 'error' : ''}
          />
        ))}
      </div>
      {touched && error && <div className="otp-error">{error}</div>}
    </div>
  );
};

export default OTPInput;



